/**
 * Form snapshot the Candid document-upload modal emits to its parent.
 *
 * @module candidDocumentUploadFormState
 */

/**
 * Parent-consumable state for the Candid document upload form.
 *
 * `isValid` is true only when the user has entered a document name and at
 * least one file has finished uploading to GCS.
 */
export interface CandidDocumentUploadFormState {
  /** Custom display name from the Document Name field. */
  docName: string;
  /** Final GCS path of the uploaded file, including extension. */
  filePath: string;
  /** Whether the form may be submitted. */
  isValid: boolean;
}

/** Empty snapshot used before the user has entered a name or uploaded a file. */
export const EMPTY_CANDID_DOCUMENT_UPLOAD_FORM_STATE: CandidDocumentUploadFormState =
  {
    docName: "",
    filePath: "",
    isValid: false,
  };
